import { render, staticRenderFns } from "./SignUpNPForm.vue?vue&type=template&id=067a5790&scoped=true"
import script from "./SignUpNPForm.vue?vue&type=script&lang=js"
export * from "./SignUpNPForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpNPForm.vue?vue&type=style&index=0&id=067a5790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a5790",
  null
  
)

export default component.exports